import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import { type ResponseHeader, ResponseHeaderSchema } from '../responseHeader'
import {
  MeshoutResponsePayload,
  MeshoutResponsePayloadSchema,
} from './meshoutResponsePayload'

export type MeshoutResponse = {
  header: ResponseHeader
  payload?: MeshoutResponsePayload
}

export const MeshoutResponseSchema: CborSchema<MeshoutResponse> =
  defineCborSchema<MeshoutResponse>({
    header: CborField({ key: 0, type: ResponseHeaderSchema }),
    payload: CborField({
      key: 1,
      required: false,
      type: MeshoutResponsePayloadSchema,
    }),
  })
